import service from './index'
import cookie from "react-cookies";
import {
  RIMS_COOKIE_CONSTANTS,
} from "../constants";

const prefix = '/cm';

//10-Category,11-Dosage Form,12-Generic Name,13-Health Authority,14-Product Type,15-Route of Administration,16-Sub Category,17-Submission Type,18-Topic,19-Trade Name

export const getCategoryTreeList = (keywords: string, domain: string, module: string, label: string) => service.get(`${prefix}/category/category-tree?keyword=${keywords}&domain=${domain}&module=${module}&label=${label}`);

// new system library api
export const getSysLibDropDownList = (params = {}) => service.get(prefix + '/dropdown-list', { params });

//menu list
export const getRtqMenuList = (
  params: {
    rtqId: string,
    rtqVersion?: string
    rtqMinorVersion?: string
  }
): Promise<API.DataResponse<Array<API.SideMenuGroup>>> =>
  service.get(`/hai/cm/side-menu`, { params });

//grid field
export const getRtqGridsFields = (params: {
  module: string;
  gridName: string;
  domain?: string;
  section?: string;
  rtqVersion?: string;
  rtqId?: string;
  items?: string[];
}): Promise<API.DataResponse<API.GridFieldsItem[]>> => service.get(prefix + `/form-manager/grids/fields`, { params });

// form config
export const apiGetFormSetting = (params: { "module": string, "formName": string, "rtqVersion"?: string, "rtqId"?: string }): AsyncResType<API_TYPES["rtqFormSettings"] | null> => service.post("/cm/form-manager/forms/settings", params)

export const apiGetTenant = (id: string): Promise<API.DataResponse<API.TenantDes>> => service.get(`/freyr-tm/tmSubscription/getByTenantId/${id}`)

export const apiFetchLifeCycleOptions = (label: string) => service.get(
  `/hai/km/dropdown-list?domain=${cookie.load(RIMS_COOKIE_CONSTANTS.DOMAIN)}&module=rtq&label=${label}`
);

/** RecordStatus KM dropdown for regulatory status badge. */
export const apiFetchRecordStatusDropdown = (): Promise<
  API.DataResponse<API.DropdownItem[]>
> =>
  service.get(
    `/hai/km/dropdown-list?domain=${cookie.load(RIMS_COOKIE_CONSTANTS.DOMAIN)}&module=rtq&label=RecordStatus`,
  );

export const getSpecifyRelatedResourceList = (body: any) => service.post('/common-uam/resources/specified/related-list', body);
